import type { ReactElement } from "react"
import { createContext, useEffect } from "react"
import useEmailHackConfigurationQuery from "@gatsby-plugin-bonus/components/EmailHackBox/useEmailHackConfigurationQuery"
import isEmpty from "~/lib/isEmpty"
import { loadUserDataForToken } from "~/store/basket/actions"
import { getBasketToken } from "~/store/basket/selectors"
import { addEmailHackData } from "~/store/bonus/actions-email-hack"
import { useAppDispatch, useAppSelector } from "~/store/hooks"
import { getUserDataReady } from "~/store/selectors"

const UserdataContext = createContext(false)

export default function UserdataContextWrapper({ children }): ReactElement {
  const dispatch = useAppDispatch()
  const token = useAppSelector(getBasketToken)
  const isReady = useAppSelector(getUserDataReady)
  const { enabled, emailHackPlan, basketText } =
    useEmailHackConfigurationQuery()

  useEffect(() => {
    dispatch(loadUserDataForToken(token))
    dispatch(
      addEmailHackData({
        enabled,
        emailHackPlanId: !isEmpty(emailHackPlan)
          ? emailHackPlan[0].flatData.id
          : undefined,
        basketText,
      })
    )
  }, [])

  return (
    <UserdataContext.Provider value={isReady}>
      {children}
    </UserdataContext.Provider>
  )
}
